import React, { useEffect, useState } from "react";
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from "react-native";
import { Modal } from "@material-ui/core";
import getPlatformType from "../../../../../helpers/helpers";
const layoutType = getPlatformType();
const DepositManagementModal = ({
  open,
  handleClose,
  type, // "create" or "edit"
  mode, // "TDS" or "SDS"
  initialData = {},
  onSubmit,
}) => {
  const isTDS = mode === "TDS";
  const isTDSNi = mode === "TDS_NI";

  const apiKeyField = isTDS ? "tds_api_key": isTDSNi? "tds_ni_api_key": "sds_api_key";

  // ---------------------- FORM STATE ----------------------
  const [memberId, setMemberId] = useState("");
  const [branchId, setBranchId] = useState("");
  const [apiKey, setApiKey] = useState("");

  // ---------------------- VALIDATION ERRORS ----------------------
  const [errors, setErrors] = useState({});

  // ---------- LOAD DEFAULT VALUES IN EDIT MODE ----------
  useEffect(() => {
    if (type === "edit" && initialData) {
      setMemberId(initialData?.member_id || "");
      setBranchId(initialData?.branch_id || "");
      setApiKey(initialData?.api_key || "");
    }
  }, [type, initialData]);

  // ---------------------- VALIDATION ----------------------
  const validate = () => {
    let temp = {};

    if (!memberId.trim()) temp.memberId = "Member ID is required";
    if (!branchId.trim()) temp.branchId = "Branch ID is required";
    if (!apiKey.trim()) temp.apiKey = `${mode} API Key is required`;

    setErrors(temp);
    return Object.keys(temp).length === 0;
  };

  // ---------------------- SUBMIT ----------------------
  const handleSave = () => {
    if (!validate()) return;

    const payload = {
      deposit_protection_type: isTDS ? "tds" :isTDSNi?"tds_ni": "sds",
      member_id: memberId,
      branch_id: branchId,
      [apiKeyField]: apiKey,
    };

    onSubmit(payload);
  };



  return (
    <Modal open={open} onClose={handleClose}>
      <View style={[styles.modalContainer, { width: layoutType === "web" ? 500 : "94%" }]}>
        <Text style={styles.title}>
          {type === "edit"
            ? `Edit ${mode} Deposit Details`
            : `Add ${mode} Deposit Details`}
        </Text>

        {/* MEMBER ID */}
        <TextInput
          style={styles.input}
          placeholder="Member ID"
          value={memberId}
          onChangeText={setMemberId}
        />
        {errors.memberId && <Text style={styles.error}>{errors.memberId}</Text>}

        {/* BRANCH ID */}
        <TextInput
          style={styles.input}
          placeholder="Branch ID"
          value={branchId}
          onChangeText={setBranchId}
        />
        {errors.branchId && <Text style={styles.error}>{errors.branchId}</Text>}

        {/* DYNAMIC API KEY */}
        <TextInput
          style={styles.input}
          placeholder={`${mode} API Key`}
          value={apiKey}
          onChangeText={setApiKey}
        />
        {errors.apiKey && <Text style={styles.error}>{errors.apiKey}</Text>}

        {/* BUTTONS */}
        <View style={styles.buttonRow}>
          <TouchableOpacity style={styles.saveButton} onPress={handleSave}>
            <Text style={styles.buttonText}>{type === "edit" ? "Edit" : "Save"}</Text>
          </TouchableOpacity>

          <TouchableOpacity style={styles.cancelButton} onPress={handleClose}>
            <Text style={styles.cancelText}>Cancel</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalContainer: {
    backgroundColor: "#fff",
    margin: "auto",
    marginTop: 100,
    width: layoutType=="web"? 500: "94%",
    padding: 20,
    borderRadius: 8,
    outline: "none",
  },
  title: {
    fontSize: 18,
    fontWeight: "700",
    marginBottom: 20,
  },
  input: {
    borderWidth: 1,
    borderColor: "#ccc",
    borderRadius: 6,
    padding: 10,
    marginBottom: 5,
    fontSize: 14,
  },
  error: {
    color: "red",
    fontSize: 12,
    marginBottom: 10,
  },
  buttonRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 15,
  },
  saveButton: {
    backgroundColor: "#9C6ADE",
    paddingVertical: 10,
    paddingHorizontal: 30,
    borderRadius: 6,
  },
  cancelButton: {
    borderWidth: 1,
    borderColor: "#f36",
    paddingVertical: 10,
    paddingHorizontal: 30,
    borderRadius: 6,
  },
  buttonText: {
    color: "#fff",
    fontWeight: "600",
  },
  cancelText: {
    color: "#f36",
    fontWeight: "600",
  },
});

export default DepositManagementModal;
